export default {
  contacts: 'Контакты',
  timeline: 'Таймлайн',
  tasks: 'Задачи',
}


// WEBPACK FOOTER //
// ./src/apps/analytics/available_modules.js